// extracted by mini-css-extract-plugin
module.exports = {"header":"header_university_header__uXFzx","logo":"header_university_logo__GvEI2"};